const removeHTMLTags = (str) => {
  if (!str) return "";
  return str.replace(/(<([^>]+)>)/gi, "")?.trim();
};

export default removeHTMLTags;
